import { ArrowRight, Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const LandingCta = () => {
  const navigate = useNavigate();

  return (
    <section className="py-12 lg:py-24 bg-white">
      <div className="max-w-[1440px] mx-auto px-6">
        <div className="bg-primary rounded-[40px] lg:rounded-[80px] p-10 lg:p-24 text-center text-white relative overflow-hidden shadow-[0_40px_100px_-20px_rgba(34,197,94,0.4)]">

          {/* Abstract background shapes */}
          <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-white opacity-10 rounded-full translate-x-1/2 -translate-y-1/2 blur-3xl pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-black opacity-5 rounded-full -translate-x-1/2 translate-y-1/2 blur-3xl pointer-events-none"></div>

          <div className="relative z-10 max-w-4xl mx-auto">
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-black tracking-tight leading-[0.95] mb-10">
              Sua jornada para o<br className="hidden lg:block" /> futuro do varejo começa agora.
            </h2>
            <p className="text-xl lg:text-3xl font-medium mb-12 lg:mb-16 opacity-90 leading-tight">
              Não espere mais para inovar. Transforme a comunicação do seu negócio e veja os resultados aparecerem.
            </p>

            <div className="flex flex-col sm:flex-row gap-6 justify-center items-stretch">
              <button
                onClick={() => navigate('/auth?signup=true')}
                className="bg-gray-900 text-white px-12 py-6 rounded-full font-black text-xl lg:text-2xl hover:scale-105 transition-all flex items-center justify-center gap-3 shadow-2xl"
              >
                Comece seu teste gratuito <ArrowRight className="w-7 h-7" />
              </button>

            </div>

            <div className="mt-12 lg:mt-16 flex flex-wrap justify-center gap-8 text-sm lg:text-lg font-black uppercase tracking-widest opacity-80">
              <span className="flex items-center gap-2">
                <Check className="w-5 h-5" /> Cancelamento Fácil
              </span>
              <span className="flex items-center gap-2">
                <Check className="w-5 h-5" /> Suporte 24/7
              </span>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};
